import React from 'react';
import { Routes as ReactRouterDomRoutes, Route } from 'react-router-dom';
import { ControllingModuleNavigation } from '../controlling/components/ControllingModuleNavigation';
import { ControllingModule } from '../controlling/components/ControllingModule';
import GlobalSider from '../../components/GlobalSider';
import { useTranslation } from 'react-i18next';
import Flex from '../../components/Flex';
import GlobalNavigationBar from '../../components/GlobalNavigationBar';
import * as Sentry from '@sentry/react';

import { makePrioStyles } from '../../theme/utils';
import classNames from 'classnames';
const Routes = Sentry.withSentryReactRouterV6Routing(ReactRouterDomRoutes);

const useStyles = makePrioStyles((theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  //@ts-ignore
  navigation: {
    height: '100%',
    overflow: 'hidden',
    backgroundColor: 'transparent',
  },
  content: {
    flex: 2,
    overflow: 'hidden',
  },
  fullHeight: {
    height: '100%',
    overflow: 'hidden',
  },
}));

export const Accounting: React.FC<{}> = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classNames('prio-deprecated-design', classes.root)}>
      <GlobalSider
        title={t('controlling:module')}
        selectedMainMenuItem={'controlling'}
        subMenu={
          <Routes>
            <Route
              path="*"
              element={
                <ControllingModuleNavigation
                  className={classes.navigation}
                  isSubMenu
                />
              }
            />
            <Route
              path=":selectedList/*"
              element={
                <ControllingModuleNavigation
                  className={classes.navigation}
                  isSubMenu
                />
              }
            />
            <Route
              path="office/:officeId/:selectedList/*"
              element={
                <ControllingModuleNavigation
                  className={classes.navigation}
                  isSubMenu
                />
              }
            />
          </Routes>
        }
      >
        <Routes>
          <Route
            path="*"
            element={
              <ControllingModuleNavigation className={classes.navigation} />
            }
          />
          <Route
            path=":selectedList/*"
            element={
              <ControllingModuleNavigation className={classes.navigation} />
            }
          />
          <Route
            path="office/:officeId/:selectedList/*"
            element={
              <ControllingModuleNavigation className={classes.navigation} />
            }
          />
        </Routes>
      </GlobalSider>
      <Flex.Column flex={1} className={classes.fullHeight}>
        <GlobalNavigationBar module="controlling" />
        <div className={classes.content}>
          <ControllingModule />
        </div>
      </Flex.Column>
    </div>
  );
};

export default Accounting;
